import { Workbox } from 'workbox-window';

/**
 * Register the service worker for PWA functionality
 * Handles caching, offline support, and automatic updates
 */
export function registerServiceWorker() {
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    const wb = new Workbox('/sw.js');

    // Show a prompt when a new service worker is waiting to activate
    wb.addEventListener('waiting', (event) => {
      console.log(
        'A new service worker has been installed, but it cannot activate until all tabs running the current version have been closed.'
      );
    });

    // Reload the page when the new service worker is activated
    wb.addEventListener('controlling', (event) => {
      console.log('Service worker activated, reloading page for latest version');
      window.location.reload();
    });

    // Log activation
    wb.addEventListener('activated', (event) => {
      if (!event.isUpdate) {
        console.log('Service worker activated for the first time');
      } else {
        console.log('Service worker updated successfully');
      }
    });

    // Register the service worker
    wb.register()
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  }
}
